import { render } from "./DeliveryNotePositionClaims.vue?vue&type=template&id=9135b018&scoped=true"
import script from "./DeliveryNotePositionClaims.vue?vue&type=script&lang=js"
export * from "./DeliveryNotePositionClaims.vue?vue&type=script&lang=js"

import "./DeliveryNotePositionClaims.vue?vue&type=style&index=0&id=9135b018&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9135b018"]])

export default __exports__